import React from 'react';
import { Card } from "react-bootstrap";
import face_laszlo_toka from "../../assets/img/face_laszlo_toka.png";
import ShowMoreText from "react-show-more-text";
import proj_context_aware_systems from "../../assets/img/proj_context_aware_systems.png";

const Laszlo_Toka_context_aware = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_context_aware_systems} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_laszlo_toka}
              /* this will be the text on the banner */
              alt="Context-Aware Systems in Vehicular Environments: Enhancing Safety and Efficiency through AI"
            />{" "}
            <p className="text7">László Toka</p>
            <br />
            <p className="text8">
              Associate Professor{" "}
            </p>
            <p className="text8">Department of Telecommunication and Artificial Intelligence, BME </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            This project focuses on the development of context-aware systems for vehicular environments, 
            leveraging artificial intelligence to improve safety, traffic management, and driver 
            experience. Students will explore how AI can process and interpret real-time data from 
            various sources such as GPS, sensors, and communication networks to create adaptive systems 
            that respond dynamically to changing conditions on the road. The project will involve modeling 
            and analyzing contextual factors like traffic density, weather conditions, and driver behavior, 
            aiming to optimize vehicle operations and reduce the likelihood of accidents. Through this 
            project, students will gain hands-on experience in applying mathematical models, machine 
            learning algorithms, and AI techniques to real-world problems, positioning them for advanced 
            work in smart transportation and autonomous vehicles.

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Laszlo_Toka_context_aware;